































































import { Vue, Component, Prop } from 'vue-property-decorator';
import draggable from 'vuedraggable';

@Component({
  components: {
    draggable
  }
})
export default class DraggableTable extends Vue {
  // Props
  @Prop(Array) public list!: object[];
  @Prop(Array) public headers!: object[];
  @Prop({ type: Boolean, default: false }) public isReadOnly!: boolean;
  @Prop({ type: Boolean, default: false }) public isEditable!: boolean;
  @Prop({ type: Boolean, default: false }) public advancedDelete!: boolean;
  @Prop(String) public link!: string;

  public deleteIndex = -1;
  public deleteId = 0;

  public deleteDialogValue = false;

  public deleteItem(index, id) {
    if (this.advancedDelete) {
      this.deleteIndex = index;
      this.deleteId = id;
      this.deleteDialogValue = true;
    } else {
      this.list.splice(index, 1);
    }
  }

  public executeDelete() {
    this.list.splice(this.deleteIndex, 1);
    this.$emit('delete', this.deleteId);
  }

  public goToLink(id) {
    if (this.link) {
      this.$router.push(this.link + String(id));
    }
  }
}
